<template>
  <v-app id="app">
    <vue-snotify />
    <router-view />
  </v-app>
</template>

<script>
export default {
  name : 'APP'
}
</script>
